export default "__VITE_ASSET__eqzu4lmb__"